import { render, staticRenderFns } from "./FormInput.vue?vue&type=template&id=71ccfe6a&"
import script from "./FormInput.vue?vue&type=script&lang=js&"
export * from "./FormInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/guave/fwgch/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('71ccfe6a')) {
      api.createRecord('71ccfe6a', component.options)
    } else {
      api.reload('71ccfe6a', component.options)
    }
    module.hot.accept("./FormInput.vue?vue&type=template&id=71ccfe6a&", function () {
      api.rerender('71ccfe6a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/fwg/js/components/FormInput.vue"
export default component.exports